import { createNotification } from "react-redux-notify";
import { all, put, select, takeLatest } from "redux-saga/effects";
import { getErrorNotificationMessage, getSuccessNotificationMessage } from "../../components/helper/NotificationMessage";
import {
  FETCH_USER_AD_START,
  CREATE_AD_CAMPAIGN_START,
  FETCH_USER_AD_START_BY_ID,
  DELETE_USER_AD_BY_ID_START,
  PUBLISH_USER_AD_BY_ID_START,
  FETCH_RECOMMENDED_AD_FOR_USER_START,
} from "../actions/ActionConstant";
import AdCampaignService from "../../helpers/services/ads/ad-campaigns";
import { parseContentServiceError } from "../../helpers/services/content/error";
import { hideErrorComponent, showErrorComponent } from "../actions/ComponentAction";
import {
  createAdsSuccess,
  createAdsFailure,
  fetchUserAdsSuccess,
  fetchUserAdsFailure,
  deleteAdByIdSuccess,
  deleteAdByIdFailure,
  fetchUserAdByIdFailure,
  fetchUserAdByIdSuccess,
  fetchRecommendedAdSuccess,
  fetchRecommendedAdFailure,
  publishUserAdByIdSuccess,
  publishUserAdByIdFailure,
} from "../actions/AdsAction";
import { fetchWalletDetailsStart } from '../actions/WalletAction';

function* createAdCampaign(action) {
  const { onUploadProgress, toggelProgressModal, onSuccess } = action.payload
  try {
    const inputData = yield select((state) => state.ads.ads.inputData);

    const response = yield AdCampaignService.create(inputData, {
      onUploadProgress: (event) => onUploadProgress(Math.ceil((event.loaded / event.total) * 100))
    })

    if (response.success) {
      yield put(createAdsSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.message
      );
      yield put(createNotification(notificationMessage));
      onSuccess(response?.data)
    } else {
      toggelProgressModal();
      const notificationMessage = getErrorNotificationMessage(parseContentServiceError(response.error));
      yield put(createNotification(notificationMessage));
      yield put(createAdsFailure(response.data.error));
    }

  } catch (error) {
    toggelProgressModal();
    if (error?.response?.status !== 400) {
      yield put(showErrorComponent({ error: error, status: error?.response?.status ? error?.response?.status : 500 }));
    }
    const notificationMessage = getErrorNotificationMessage(parseContentServiceError(error.response));
    yield put(createNotification(notificationMessage));
  }
};

function* fetchAdCampaigns() {
  try {
    const response = yield AdCampaignService.fetchAll();
    if (response.result.length > 0) {
      yield put(fetchUserAdsSuccess(response.result));
    } else {
      yield put(fetchUserAdsFailure(response));
    }
    yield put(hideErrorComponent());
  } catch (error) {
    const notificationMessage = getErrorNotificationMessage( 
      error?.response ? parseContentServiceError(error.response) : 'Unable to fetch ads.'
    );
    yield put(createNotification(notificationMessage));
    yield put(fetchUserAdsFailure(error));
  }
}

function* fetchAdCampaignById(action) {
  try {
    const response = yield AdCampaignService.fetchById(action.payload);
    if (response.success) {
      yield put(fetchUserAdByIdSuccess(response.data));
    } else {
      yield put(fetchUserAdByIdFailure(response));
    }
    yield put(hideErrorComponent());
  } catch (error) {
    yield put(fetchUserAdByIdFailure(error));
  }
}

function* fetchRecommendedAds(action) {
  try {
    const response = yield AdCampaignService.fetchRecommended(action.payload);
    if (response.success) {
      yield put(fetchRecommendedAdSuccess(response.ads));
    } else {
      yield put(fetchRecommendedAdFailure(response));
    }
    yield put(hideErrorComponent());
  } catch (error) {
    yield put(fetchRecommendedAdFailure(error));
  }
}

function* publishAdCampaign(action) {
  const { ad_id, callback, errorCallback } = action.payload;
  try {
    const response = yield AdCampaignService.publish(ad_id);
    if (response.success) {
      yield put(publishUserAdByIdSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.message
      );
      yield put(createNotification(notificationMessage));
      yield put(fetchWalletDetailsStart());
      callback();
    } else {
      const notificationMessage = getErrorNotificationMessage(parseContentServiceError(response.error));
      yield put(createNotification(notificationMessage));
      yield put(publishUserAdByIdFailure(response));
      errorCallback();
    }
    yield put(hideErrorComponent());
  } catch (error) {
    errorCallback();
    if (error?.response?.status !== 400) {
      yield put(showErrorComponent({ error: error, status: error?.response?.status ? error?.response?.status : 500 }));
    }
    const notificationMessage = getErrorNotificationMessage(parseContentServiceError(error.response));
    yield put(createNotification(notificationMessage));
    yield put(publishUserAdByIdFailure(error));
  }
}

function* deleteAdCampaign(action) {
  const { ad_id, callback, errorCallback } = action.payload;
  try {
    const response = yield AdCampaignService.remove(ad_id);
    if (response.success) {
      yield put(deleteAdByIdSuccess(ad_id));
      const notificationMessage = getSuccessNotificationMessage(
        response.message
      );
      yield put(createNotification(notificationMessage));
      callback();
    } else {
      const notificationMessage = getErrorNotificationMessage(parseContentServiceError(response.error));
      yield put(createNotification(notificationMessage));
      yield put(deleteAdByIdFailure(response));
      errorCallback();
    }
    yield put(hideErrorComponent());
  } catch (error) {
    if (error?.response?.status !== 400) {
      yield put(showErrorComponent({ error: error, status: error?.response?.status ? error?.response?.status : 500 }));
    }
    const notificationMessage = getErrorNotificationMessage(parseContentServiceError(error.response));
    yield put(createNotification(notificationMessage));
    yield put(deleteAdByIdFailure(error));
    errorCallback();
  }
}

export default function* pageSaga() {
  yield all([
    takeLatest(CREATE_AD_CAMPAIGN_START, createAdCampaign),
    takeLatest(FETCH_USER_AD_START, fetchAdCampaigns),
    takeLatest(FETCH_USER_AD_START_BY_ID, fetchAdCampaignById),
    takeLatest(FETCH_RECOMMENDED_AD_FOR_USER_START, fetchRecommendedAds),
    takeLatest(PUBLISH_USER_AD_BY_ID_START, publishAdCampaign),
    takeLatest(DELETE_USER_AD_BY_ID_START, deleteAdCampaign),
  ]);
};
